<template>
  <pagefra>
    <div
      class="analyseIndex"
      v-loading.fullscreen.lock="exportLoading"
      :element-loading-text="$l('正在导出中')"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <el-row type="flex" :gutter="basePadding">
        <el-col class="col5-2" v-if="hasPermission('单梯体检报告')">
          <div
            class="card card--dark card--type01"
            @click="openElevatorMedicalReport"
          >
            <span>
              <svgicon name="screen_report" :original="true"></svgicon>
            </span>
            <p>{{ $l("单梯体检报告") }}</p>
          </div>
        </el-col>
        <el-col class="col5-1" v-if="hasPermission('故障清单报表')">
          <div class="card" @click="openFault">
            <span>
              <svgicon name="screen_list" :original="true"></svgicon>
            </span>
            <p>{{ $l("故障清单报表") }}</p>
          </div>
        </el-col>
        <el-col class="col5-1" v-if="hasPermission('维保实绩报表')">
          <div class="card" @click="openMainPlan">
            <span>
              <svgicon name="screen_shield" :original="true"></svgicon>
            </span>
            <p>{{ $l("维保实绩报表") }}</p>
          </div>
        </el-col>
        <el-col class="col5-1" v-if="hasPermission('运行状态报表')">
          <div class="card" @click="openRunStatus">
            <span>
              <svgicon name="screen_run" :original="true"></svgicon>
            </span>
            <p>{{ $l("运行状态报表") }}</p>
          </div>
        </el-col>
        <el-col class="col5-2" v-if="hasPermission('合同体检报告')">
          <div
            class="card card--dark card--type02"
            @click="openContractMedicalReport"
          >
            <span>
              <svgicon name="screen_monitor" :original="true"></svgicon>
            </span>
            <p>{{ $l("合同体检报告") }}</p>
          </div>
        </el-col>
        <el-col class="col5-2" v-if="hasPermission('配件更换预测报表')">
          <div
            class="card card--dark card--type03"
            @click="openAccessoriesReplace"
          >
            <span>
              <svgicon name="screen_time" :original="true"></svgicon>
            </span>
            <p>{{ $l("配件更换预测报表") }}</p>
          </div>
        </el-col>
        <!-- <el-col class="col5-1">
          <div class="card">
            <span>
              <svgicon name="screen_add" :original="true"></svgicon>
            </span>
            <p>自定义报表 1</p>
          </div>
        </el-col>-->
      </el-row>
      <el-dialog
        :title="$l('导出故障清单报表')"
        :visible.sync="faultReportDialogVisible"
        :close-on-click-modal="closeOnClickModal"
        width="1200px"
        @open="openFaultDialog"
      >
        <el-form :inline="true" :model="reportForm">
          <!-- <el-form-item label="所属区域">
            <areaCascader
              ref="ac"
              :multiple="true"
              :checkStrictly="true"
              :placeholder="cascaderLabel"
            ></areaCascader>
          </el-form-item> -->
          <el-form-item :label="$l('城市')">
            <el-input v-model="reportForm.city"></el-input>
          </el-form-item>
          <el-form-item :label="$l('地盘')">
            <remoteSelect
              ref="rsDomain"
              :city="reportForm.city"
              :inputLimit="1"
              :select="select"
            ></remoteSelect>
          </el-form-item>
          <el-form-item :label="$l('工号')">
            <remoteSelect
              ref="rsJobNum"
              :city="reportForm.city"
              :level="4"
              :getParentValues="getParentValues"
              :isRelated="true"
            >
            </remoteSelect>
          </el-form-item>
          <el-form-item :label="$l('报警信息')">
            <el-input v-model="reportForm.description"></el-input>
          </el-form-item>
          <el-form-item :label="$l('注册代码')">
            <el-input v-model="reportForm.registerCode"></el-input>
          </el-form-item>
          <el-form-item :label="$l('报警时间')">
            <el-date-picker
              v-model="timeValues"
              type="datetimerange"
              :picker-options="pickerOptions"
              :range-separator="$l('至')"
              :start-placeholder="$l('开始日期')"
              :end-placeholder="$l('结束日期')"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              circle
              @click="search"
            ></el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="filterTable"
          size="medium"
          tooltip-effect="tableTooltip"
          highlight-current-row
          v-loading.lock="loading"
          :data="tableData"
          border
          style="width: 100%; z-index: 1000"
        >
          <el-table-column
            type="index"
            :label="$l('序号')"
            min-width="80"
            align="center"
          ></el-table-column>
          <el-table-column
            :label="$l('城市')"
            prop="city"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('地盘名称')"
            prop="domainName"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('大楼名称')"
            prop="buildingName"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('梯号')"
            prop="elevatorNum"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('电梯工号')"
            prop="jobNum"
            align="center"
            min-width="120"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('梯龄')"
            prop="elevatorAge"
            align="center"
            min-width="120"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('报警时间')"
            prop="alarmDate"
            min-width="120"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('报警信息')"
            prop="description"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span :title="scope.row.description">{{
                scope.row.description && scope.row.description.length > 20
                  ? scope.row.description.substring(0, 20) + "..."
                  : scope.row.description
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$l('是否困人')"
            prop="boxUp"
            align="center"
            min-width="80"
          ></el-table-column>
          <el-table-column
            :label="$l('下单来源')"
            prop="serviceRequestSource"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            :label="$l('处理方式')"
            prop="processTypeText"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            :label="$l('派工时间')"
            prop="processDate"
            min-width="120"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('到场时间')"
            prop="arriveDate"
            min-width="120"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('报警解除时间')"
            prop="finishDate"
            min-width="120"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('电梯品牌')"
            prop="brand"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('注册代码')"
            prop="registerCode"
            align="center"
            min-width="150"
            sortable
          ></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="faultReportDialogVisible = false">{{
            $l("取 消")
          }}</el-button>
          <el-button type="primary" @click="exportFaultReport"
            >{{ $l("导出") }}
          </el-button>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </el-dialog>
      <el-dialog
        :title="$l('导出维保实绩报表')"
        :visible.sync="mainPlanReportDialogVisible"
        :close-on-click-modal="closeOnClickModal"
        width="1200px"
        @open="openMainDialog"
      >
        <el-form :inline="true" :model="reportForm">
          <!-- <el-form-item label="所属区域">
            <areaCascader
              ref="ac"
              :multiple="true"
              :checkStrictly="true"
              :placeholder="cascaderLabel"
            ></areaCascader>
          </el-form-item> -->
          <el-form-item :label="$l('城市')">
            <el-input v-model="reportForm.city"></el-input>
          </el-form-item>
          <el-form-item :label="$l('地盘')">
            <remoteSelect
              ref="rsDomain"
              :inputLimit="1"
              :select="select"
            ></remoteSelect>
          </el-form-item>
          <el-form-item :label="$l('工号')">
            <remoteSelect
              ref="rsJobNum"
              :level="4"
              :getParentValues="getParentValues"
              :isRelated="true"
            ></remoteSelect>
          </el-form-item>
          <el-form-item :label="$l('注册代码')">
            <el-input v-model="reportForm.registerCode"></el-input>
          </el-form-item>
          <el-form-item :label="$l('开始计划时间')">
            <el-date-picker
              v-model="timeValues"
              type="datetimerange"
              :picker-options="pickerOptions"
              :range-separator="$l('至')"
              :start-placeholder="$l('开始日期')"
              :end-placeholder="$l('结束日期')"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              circle
              @click="search"
            ></el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="filterTable"
          size="medium"
          tooltip-effect="tableTooltip"
          highlight-current-row
          v-loading.lock="loading"
          :data="tableData"
          border
          style="width: 100%; z-index: 1000"
        >
          <el-table-column
            :label="$l('序号')"
            type="index"
            min-width="80"
            align="center"
          ></el-table-column>
          <el-table-column
            :label="$l('城市')"
            prop="city"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('地盘名称')"
            prop="domainName"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('大楼名称')"
            prop="buildingName"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('梯号')"
            prop="elevatorNum"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('工号')"
            prop="jobNum"
            align="center"
            min-width="150"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('梯龄')"
            prop="elevatorAge"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('注册代码')"
            prop="registerCode"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('维保计划开始时间')"
            prop="planStartDt"
            align="center"
            min-width="150"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('维保计划结束时间')"
            prop="planEndDt"
            align="center"
            min-width="150"
            sortable
          ></el-table-column>
          <!-- <el-table-column :label="$l('计划年')" prop="planYear" align="center" min-width="150" sortable></el-table-column>
          <el-table-column :label="$l('计划月')" prop="planMonth" align="center" min-width="150"></el-table-column> -->
          <el-table-column
            :label="$l('计划状态')"
            prop="planStatus"
            align="center"
            min-width="150"
          >
          </el-table-column>
          <el-table-column
            :label="$l('计划次数')"
            prop="planTimes"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('保养员工名称集合')"
            prop="workEmpNames"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('作业人员名称集合')"
            prop="planEmpNames"
            align="center"
            min-width="150"
          ></el-table-column>
          <!-- <el-table-column :label="$l('计划人员1')" prop="planEmpName1" align="center" min-width="150"></el-table-column>
          <el-table-column :label="$l('计划人员2')" prop="planEmpName2" align="center" min-width="150"></el-table-column>
          <el-table-column :label="$l('计划人员3')" prop="planEmpName3" align="center" min-width="150"></el-table-column> -->
          <el-table-column
            :label="$l('实际开始时间')"
            prop="actualStartDt"
            align="center"
            min-width="150"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('实际结束时间')"
            prop="actualEndDt"
            align="center"
            min-width="150"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('实际维保人员') + 1"
            prop="actualEmpName1"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('实际维保人员') + 2"
            prop="actualEmpName2"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('实际维保人员') + 3"
            prop="actualEmpName3"
            align="center"
            min-width="150"
          ></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="mainPlanReportDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="exportMainPlanReport"
            >{{ $l("导出") }}
          </el-button>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </el-dialog>
      <el-dialog
        :title="$l('导出运行状态报表')"
        :visible.sync="runStatusReportDialogVisible"
        :close-on-click-modal="closeOnClickModal"
        width="1200px"
        @open="openRunDialog"
      >
        <el-form :inline="true" :model="reportForm">
          <!-- <el-form-item :label="$l('所属区域')">
            <areaCascader
              ref="ac"
              :multiple="true"
              :checkStrictly="true"
              :placeholder=":cascaderLabel"$l('
            ></')areaCascader>
          </el-form-item> -->
          <el-form-item :label="$l('城市')">
            <el-input v-model="reportForm.city"></el-input>
          </el-form-item>
          <el-form-item :label="$l('地盘')">
            <remoteSelect
              ref="rsDomain"
              :inputLimit="1"
              :select="select"
            ></remoteSelect>
          </el-form-item>
          <el-form-item :label="$l('工号')">
            <remoteSelect
              ref="rsJobNum"
              :level="4"
              :getParentValues="getParentValues"
              :isRelated="true"
            ></remoteSelect>
          </el-form-item>
          <el-form-item :label="$l('注册代码')">
            <el-input v-model="reportForm.registerCode"></el-input>
          </el-form-item>
          <el-form-item :label="$l('最后上线时间')">
            <el-date-picker
              v-model="timeValues"
              type="daterange"
              :picker-options="pickerOptions2"
              :range-separator="$l('至')"
              :start-placeholder="$l('开始日期')"
              :end-placeholder="$l('结束日期')"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              circle
              @click="search"
            ></el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="filterTable"
          size="medium"
          tooltip-effect="tableTooltip"
          highlight-current-row
          v-loading.lock="loading"
          :data="tableData"
          border
          style="width: 100%; z-index: 1000"
        >
          <el-table-column
            :label="$l('序号')"
            type="index"
            min-width="80"
            align="center"
          ></el-table-column>
          <el-table-column
            :label="$l('城市')"
            prop="city"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('分公司')"
            prop="filiale"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('客户')"
            prop="customer"
            align="center"
            min-width="150"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('地盘')"
            prop="building"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('保养站')"
            prop="companydesc"
            align="center"
            min-width="150"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('安装地址')"
            prop="installsite"
            align="center"
            min-width="150"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('工号')"
            prop="deviceno"
            align="center"
            min-width="150"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('注册代码')"
            prop="registerCode"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('梯种')"
            prop="modeldesc"
            align="center"
            min-width="150"
          ></el-table-column>
          <!-- <el-table-column :label="$l('终端类型')" prop="protocoldesc" align="center" min-width="150"></el-table-column>
          <el-table-column :label="$l('程序版本')" prop="mainversion" align="center" min-width="150"></el-table-column> -->
          <el-table-column
            :label="$l('电话卡号码')"
            prop="phone"
            align="center"
            min-width="150"
          ></el-table-column>
          <!-- <el-table-column :label="$l('端口号')" prop="terminalport" align="center" min-width="150"></el-table-column> -->
          <el-table-column
            :label="$l('激活状态')"
            prop="activestatus"
            align="center"
            min-width="150"
            sortable
          ></el-table-column>
          <!-- <el-table-column :label="$l('调试状态')" prop="debugstatus" align="center" min-width="150" sortable></el-table-column> -->
          <el-table-column
            :label="$l('终端断开')"
            prop="terminalcut"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('采集板断开')"
            prop="watchcut"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('最后上线时间')"
            prop="lastcontactdate"
            align="center"
            min-width="150"
          ></el-table-column>
          <!-- <el-table-column :label="$l('换卡次数')" prop="editcount" align="center" min-width="150"></el-table-column> -->
          <el-table-column
            :label="$l('卡状态')"
            prop="cardstatus"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('卡备注')"
            prop="cardremark"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('技检发证日期')"
            prop="govcheckdate"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('维保开始时间')"
            prop="servicestartdate"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('维保结束时间')"
            prop="serviceenddate"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('保养延期时间')"
            prop="servicedelaydate"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('在保状态')"
            prop="servicedesc"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('备注')"
            prop="remark"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('遥监方案')"
            prop="watchworkdesc"
            align="center"
            min-width="150"
          ></el-table-column>
          <!-- <el-table-column :label="$l('遥监发货')" prop="deliverydesc" align="center" min-width="150"></el-table-column>
          <el-table-column :label="$l('遥监安装')" prop="installdesc" align="center" min-width="150"></el-table-column>
          <el-table-column :label="$l('遥监拆回')" prop="isremoveback" align="center" min-width="150"></el-table-column> -->
          <el-table-column
            :label="$l('遥监调试')"
            prop="debugdesc"
            align="center"
            min-width="150"
          ></el-table-column>
          <!-- <el-table-column :label="$l('遥监激活（统计）')" prop="activetotal" align="center" min-width="150"></el-table-column>
          <el-table-column :label="$l('监视状态')(统计）" prop="normalmonitortotal" align="center" min-width="150"></el-table-column> -->
          <!-- <el-table-column :label="$l('监视条件')" prop="normalmonitor" align="center" min-width="150"></el-table-column>
          <el-table-column :label="$l('说明1')" prop="watchworkreason1" align="center" min-width="150"></el-table-column>
          <el-table-column :label="$l('说明2')" prop="watchworkreason2" align="center" min-width="150"></el-table-column>
          <el-table-column :label="$l('推广备注')" prop="spreadremark" align="center" min-width="150"></el-table-column> -->
          <el-table-column
            :label="$l('运行次数原始数据')"
            prop="runTimesOr"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('运行时间原始数据')"
            prop="totalTimeOr"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('开关门次数原始数据')"
            prop="opendoorTimesOr"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('遥监数据收集时间')"
            prop="dataCollectDatetime"
            align="center"
            min-width="150"
          ></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="runStatusReportDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="exportRunStatusReport"
            >{{ $l("导出") }}
          </el-button>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </el-dialog>
      <el-dialog
        :title="$l('导出配件更换预测报表')"
        :visible.sync="accessoriesReplaceReportDialogVisible"
        :close-on-click-modal="closeOnClickModal"
        width="900px"
      >
        <el-form :inline="true" :model="accessoriesReplaceReportForm">
          <!-- <el-form-item :label="$l('工号')">
            <areaCascader ref="ac" :placeholder=":cascaderLabel"></$l('areaCascader')>
          </el-form-item> -->
          <el-form-item :label="$l('地盘')">
            <remoteSelect
              ref="rsDomain"
              :inputLimit="1"
              :multiple="false"
              :select="select"
            ></remoteSelect>
          </el-form-item>
          <el-form-item :label="$l('工号')">
            <remoteSelect
              ref="rsJobNum"
              :level="4"
              :getParentValues="getParentValues"
              :multiple="false"
              :isRelated="true"
            ></remoteSelect>
          </el-form-item>
          <el-form-item :label="$l('城市')">
            <el-input v-model="reportForm.city"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="accessoriesReplaceReportDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="exportAccessoriesReplaceReport"
            >{{ $l("导出") }}
          </el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="$l('导出单梯体检报告')"
        :visible.sync="elevatorMedicalReportDialogVisible"
        :close-on-click-modal="closeOnClickModal"
        width="900px"
      >
        <el-form :inline="true" :model="elevatorMedicalReportForm">
          <!-- <el-form-item :label="$l('工号')">
            <areaCascader ref="ac" :placeholder=":cascaderLabel"></$l('areaCascader')>
          </el-form-item> -->
          <el-form-item :label="$l('地盘')">
            <remoteSelect
              ref="rsDomain"
              :inputLimit="1"
              :multiple="false"
              :select="select"
            ></remoteSelect>
          </el-form-item>
          <el-form-item :label="$l('工号')">
            <remoteSelect
              ref="rsJobNum"
              :level="4"
              :getParentValues="getParentValues"
              :multiple="false"
              :isRelated="true"
            ></remoteSelect>
          </el-form-item>
          <el-form-item :label="$l('城市')">
            <el-input v-model="reportForm.city"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="elevatorMedicalReportDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="exportElevatorMedicalReport"
            >{{ $l("导出") }}
          </el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="$l('导出合同版体检报告')"
        :visible.sync="contractMedicalReportDialogVisible"
        :close-on-click-modal="closeOnClickModal"
        width="1000px"
      >
        <el-form :inline="true" :model="contractMedicalReportForm">
          <!-- <el-form-item :label="$l('合同号')">
            <areaCascader ref="ac" :type="3" :placeholder=":cascaderLabel"></$l('areaCascader')>
          </el-form-item> -->
          <el-form-item :label="$l('地盘')">
            <remoteSelect
              ref="rsDomain"
              :inputLimit="1"
              :multiple="false"
              :select="select"
            ></remoteSelect>
          </el-form-item>
          <el-form-item :label="$l('合同号')">
            <remoteSelect
              ref="rsAgreeNum"
              :inputLimit="3"
              :level="4"
              :type="3"
              :getParentValues="getParentValues"
              :multiple="false"
              :isRelated="true"
            ></remoteSelect>
          </el-form-item>
          <el-form-item :label="$l('时间')">
            <el-date-picker
              v-model="contractMonthRange"
              type="monthrange"
              :range-separator="$l('至')"
              :start-placeholder="$l('开始日期')"
              :end-placeholder="$l('结束日期')"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="contractMedicalReportDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="exportContractMedicalReport"
            >{{ $l("导出") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import areaCascader from "@/components/areaCascader.vue";
import remoteSelect from "@/components/remoteSelect.vue";
import global from "@/mixins/global.js";
export default {
  // name: "index",
  mixins: [global],
  components: {
    panel,
    breadcrumb,
    areaCascader,
    remoteSelect,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: this.$l("最近一周"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$l("最近一个月"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$l("最近三个月"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      pickerOptions2: {
        onPick: ({ maxDate, minDate }) => {
          this.curDate = minDate.getTime();
          if (maxDate) {
            this.curDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.curDate - one;
            const maxTime = this.curDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      reportForm: {
        pageNum: 1,
        pageSize: 10,
        description: "",
        city: "",
        registerCode: "",
        startDate: "",
        endDate: "",
        startPlanDate: "",
        endPlanDate: "",
        domainIdList: [],
        jobNumList: [],
      },
      faultReportDialogVisible: false,
      timeValues: [],
      mainPlanReportDialogVisible: false,
      runStatusReportDialogVisible: false,
      accessoriesReplaceReportForm: {
        elevator_code: "",
      },
      accessoriesReplaceReportDialogVisible: false,
      elevatorMedicalReportForm: {
        host: "",
        elevator_code: "",
      },
      elevatorMedicalReportDialogVisible: false,
      contractMedicalReportForm: {
        host: "",
        contract_code: "",
        start_date_year: "",
        start_date_month: "",
        end_date_year: "",
        end_date_month: "",
      },
      contractMedicalReportDialogVisible: false,
      contractMonthRange: [],
      exportLoading: false,
      closeOnClickModal: false,
      cascaderLabel: "",
      tableData: [],
      loading: false,
      type: 0,
    };
  },
  methods: {
    getParentValues() {
      return {
        domainIds: this.$refs.rsDomain.getValues(),
      };
    },
    select(item) {
      this.$refs.rsJobNum.remoteMethod(item);
    },
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      this.reportForm.pageNum = this.pageConfig.currentPage;
      this.reportForm.pageSize = this.pageConfig.pageSize;
      if (this.type != 3 && !this.getTimes()) {
        return;
      }
      let url = "";
      if (this.type == 1) {
        url = this.$apiConfig.search_alarm_report_url;
      } else if (this.type == 2) {
        url = this.$apiConfig.search_main_plan_report_url;
      } else if (this.type == 3) {
        url = this.$apiConfig.search_run_status_report_url;
      }
      this.setRelatedSelectCondition();
      this.tableData = [];
      this.loading = true;
      this.$http
        .post(url, this.reportForm)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    openFaultDialog() {
      this.initTabel();
      this.type = 1;
    },
    openMainDialog() {
      this.initTabel();
      this.type = 2;
    },
    openRunDialog() {
      this.initTabel();
      this.type = 3;
    },
    initTabel() {
      this.tableData = [];
      this.pageConfig.currentPage = 1;
      this.pageConfig.pageSize = 10;
      this.pageConfig.total = 0;
      this.timeValues = [];
    },
    openFault() {
      this.faultReportDialogVisible = true;
      this.reportForm.city = "";
      this.reportForm.registerCode = "";
    },
    openMainPlan() {
      this.mainPlanReportDialogVisible = true;
      this.reportForm.city = "";
      this.reportForm.registerCode = "";
    },
    openRunStatus() {
      this.runStatusReportDialogVisible = true;
      this.reportForm.city = "";
      this.reportForm.registerCode = "";
    },
    openAccessoriesReplace() {
      this.accessoriesReplaceReportDialogVisible = true;
      this.reportForm.city = "";
    },
    openElevatorMedicalReport() {
      this.elevatorMedicalReportDialogVisible = true;
      this.reportForm.city = "";
    },
    openContractMedicalReport() {
      this.contractMedicalReportDialogVisible = true;
    },
    export(url, params, filename) {
      filename = filename.replace(
        ".",
        "_" + this.$common.formatCurrentDateTime(false) + "."
      );
      for (const key in params) {
        const v = params[key];
        if (v instanceof Date) {
          params[key] = this.$common.formatDateTime(v);
        }
      }
      this.$http({
        url: url,
        method: "post",
        responseType: "blob",
        data: params,
      })
        .then((response) => {
          this.exportLoading = false;
          const status = response.status;
          if (status != 200) {
            this.message(
              1,
              status == 201
                ? "导出失败"
                : status == 202
                ? "没有数据"
                : "数据量过大"
            );
            return;
          }
          const data = response.data;
          // var blob = new Blob([data], {
          //   type: "application/vnd.ms-excel;charset=utf-8"
          // });
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = filename;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.exportLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    exportFaultReport() {
      // const idArr = this.$refs.ac.getSelectedList();
      // if (idArr.length == 0) {
      //   this.message(1, "请选择所属区域");
      //   return;
      // }
      // this.reportForm.dataPermissionList = idArr;
      if (!this.getTimes()) {
        return;
      }
      this.setRelatedSelectCondition();
      this.exportLoading = true;
      this.export(
        this.$apiConfig.export_alarm_report_url,
        this.reportForm,
        this.$l("故障清单报表") + ".xlsx"
      );
    },
    exportMainPlanReport() {
      // const idArr = this.$refs.ac.getSelectedList();
      // if (idArr.length == 0) {
      //   this.message(1, "请选择所属区域");
      //   return;
      // }
      if (!this.getTimes()) {
        return;
      }
      this.setRelatedSelectCondition();
      this.exportLoading = true;
      this.export(
        this.$apiConfig.export_main_plan_report_url,
        this.reportForm,
        this.$l("维保实绩报表") + ".xlsx"
      );
    },
    exportRunStatusReport() {
      // const idArr = this.$refs.ac.getSelectedList();
      // if (idArr.length == 0) {
      //   this.message(1, "请选择所属区域");
      //   return;
      // }
      // if (!this.getTimes()) {
      //   return;
      // }
      this.setRelatedSelectCondition();
      this.exportLoading = true;
      this.export(
        this.$apiConfig.export_run_status_report_url,
        this.reportForm,
        this.$l("运行状态报表") + ".xlsx"
      );
    },
    setRelatedSelectCondition() {
      this.reportForm.domainIdList = [];
      this.reportForm.jobNumList = [];
      let domainIdArr = this.$refs.rsDomain.getValues();
      let values = this.$refs.rsJobNum.getValues();
      domainIdArr.forEach((domainId, i) => {
        if (values.filter((v) => v.split(",")[0] == domainId).length == 0) {
          this.reportForm.domainIdList.push(domainId);
        }
      });
      values.forEach((v, i) => {
        let arr = v.split(",");
        if (
          this.reportForm.domainIdList.filter((domainId) => domainId == arr[0])
            .length == 0
        ) {
          this.reportForm.jobNumList.push(arr[1]);
        }
      });
    },
    getTimes() {
      if (this.timeValues && this.timeValues.length == 2) {
        if (this.type == 1) {
          this.reportForm.startDate = this.$common.formatDateTime(
            this.timeValues[0]
          );
          this.reportForm.endDate = this.$common.formatDateTime(
            this.timeValues[1]
          );
        } else if (this.type == 2) {
          this.reportForm.startPlanDate = this.$common.formatDateTime(
            this.timeValues[0]
          );
          this.reportForm.endPlanDate = this.$common.formatDateTime(
            this.timeValues[1]
          );
        } else {
          this.reportForm.startDate = this.$common.formatDate(
            this.timeValues[0]
          );
          this.reportForm.endDate = this.$common.formatDate(this.timeValues[1]);
        }
        return true;
      } else {
        this.message(1, "请选择日期时间");
        return false;
      }
    },
    exportAccessoriesReplaceReport() {
      let jobNum = this.$refs.rsJobNum.getValues();
      if (jobNum.length == 0) {
        this.message(1, "请选择工号");
        return;
      } else {
        jobNum = jobNum.split(",")[1];
      }
      this.accessoriesReplaceReportForm.elevator_code = jobNum;
      this.exportLoading = true;
      this.export(
        this.$apiConfig.export_accessories_replace_report_url,
        this.accessoriesReplaceReportForm,
        this.$l("配件更换预测报表") + ".xlsx"
      );
    },
    exportElevatorMedicalReport() {
      let jobNum = this.$refs.rsJobNum.getValues();
      if (jobNum.length == 0) {
        this.message(1, "请选择工号");
        return;
      } else {
        jobNum = jobNum.split(",")[1];
      }
      this.elevatorMedicalReportForm.elevator_code = jobNum;
      this.elevatorMedicalReportForm.host = this.$apiConfig.root_host;
      this.exportLoading = true;
      this.export(
        this.$apiConfig.export_elevator_medical_report_url,
        this.elevatorMedicalReportForm,
        jobNum + "-" + this.$l("直梯-单梯版-体检报告") + ".pdf"
      );
    },
    exportContractMedicalReport() {
      const contractCode = this.$refs.rsAgreeNum.getValues();
      if (contractCode.length == 0) {
        this.message(1, "请选择合同号");
        return;
      }
      this.contractMedicalReportForm.contract_code = contractCode;
      // if (this.contractMedicalReportForm.contract_code.trim().length == 0) {
      //   this.message(1, "请输入合同号");
      //   return;
      // }
      if (!this.contractMonthRange || this.contractMonthRange.length != 2) {
        this.message(1, "请选择时间");
        return;
      }
      const startTime = this.contractMonthRange[0];
      this.contractMedicalReportForm.start_date_year = startTime.getFullYear();
      this.contractMedicalReportForm.start_date_month =
        startTime.getMonth() + 1;
      const endTime = this.contractMonthRange[1];
      this.contractMedicalReportForm.end_date_year = endTime.getFullYear();
      this.contractMedicalReportForm.end_date_month = endTime.getMonth() + 1;
      this.contractMedicalReportForm.host = this.$apiConfig.root_host;
      this.exportLoading = true;
      this.export(
        this.$apiConfig.export_contract_medical_report_url,
        this.contractMedicalReportForm,
        this.contractMedicalReportForm.contract_code +
          "-" +
          this.$l("合同版体检报告") +
          ".pdf"
      );
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.analyseIndex {
  .el-row {
    flex-wrap: wrap;
  }
  .card {
  }
}
.card {
  position: relative;
  min-height: 220px;
  height: 27vh;
  // height: 276px;
  border-radius: $--border-radius-large;
  border: 1px solid $--border-color-base;
  background: #fff url("../../assets/img/screen_bg.png") no-repeat center;
  background-size: cover;
  padding: 30px;
  margin-bottom: $--base-padding;
  span {
    display: inline-block;
    // width: 78px;
    // height: 78px;
    padding: 19px;
    border-radius: 50%;
    background: $--background-color-base;
    // display: flex;
    // align-items: center;
    // justify-items: center;
  }
  svg {
    width: 40px;
    height: 40px;
  }
  p {
    position: absolute;
    left: 30px;
    bottom: 30px;
    font-size: $--font-size-large;
  }
  &--dark {
    color: #fff;
    span {
      padding: 24px;
      // background: mix(#fff, $--color-black, 10%);
      background: rgba(#fff, 0.2);
    }
    svg {
      width: 54px;
      height: 54px;
    }
  }
  &--type01 {
    background-image: url("../../assets/img/screen_bg_01.png");
  }
  &--type02 {
    background-image: url("../../assets/img/screen_bg_02.png");
  }
  &--type03 {
    background-image: url("../../assets/img/screen_bg_03.png");
  }
}

.col5-1 {
  width: 20%;
}
.col5-2 {
  width: 40%;
}

.el-dialog .el-form {
  .el-form-item {
    margin-bottom: 10px;
  }
}
/deep/ .el-range-separator{
  width: 7%;
}
</style>
